import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export function Container(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4 4 C 2.9069372 4 2 4.9069372 2 6 L 2 18 C 2 19.093063 2.9069372 20 4 20 L 20 20 C 21.093063 20 22 19.093063 22 18 L 22 6 C 22 4.9069372 21.093063 4 20 4 L 4 4 z M 4 6 L 20 6 L 20 18 L 4 18 L 4 6 z" />
    </SvgIcon>
  );
}

export function Col(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 9 2 C 7.9069372 2 7 2.9069372 7 4 L 7 20 C 7 21.093063 7.9069372 22 9 22 L 15 22 C 16.093063 22 17 21.093063 17 20 L 17 4 C 17 2.9069372 16.093063 2 15 2 L 9 2 z M 9 4 L 15 4 L 15 20 L 9 20 L 9 4 z" />
    </SvgIcon>
  );
}

export function Row(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4 7 C 2.9069372 7 2 7.9069372 2 9 L 2 15 C 2 16.093063 2.9069372 17 4 17 L 20 17 C 21.093063 17 22 16.093063 22 15 L 22 9 C 22 7.9069372 21.093063 7 20 7 L 4 7 z M 4 9 L 20 9 L 20 15 L 4 15 L 4 9 z" />
    </SvgIcon>
  );
}

export function Hidden(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4.2070312 2.7929688 L 2.7929688 4.2070312 L 5.0820312 6.4960938 C 2.4151866 8.6404109 1.1608367 11.416191 1.0800781 11.605469 L 0.91210938 12 L 1.0800781 12.394531 C 1.2130781 12.705531 4.428 20 12 20 C 14.066349 20 15.797205 19.449537 17.238281 18.652344 L 19.792969 21.207031 L 21.207031 19.792969 L 4.2070312 2.7929688 z M 12 4 C 10.789 4 9.7000313 4.200625 8.7070312 4.515625 L 10.353516 6.1621094 C 10.874516 6.0631094 11.419 6 12 6 C 17.396 6 20.167625 10.588094 20.890625 11.996094 C 20.596625 12.559094 19.952359 13.651953 18.943359 14.751953 L 20.369141 16.177734 C 22.049141 14.359734 22.854922 12.545531 22.919922 12.394531 L 23.087891 12 L 22.919922 11.605469 C 22.786922 11.294469 19.572 4 12 4 z M 6.5117188 7.9257812 L 8.5625 9.9765625 C 8.2079471 10.569059 8 11.258899 8 12 C 8 14.206 9.794 16 12 16 C 12.741101 16 13.430941 15.792053 14.023438 15.4375 L 15.748047 17.162109 C 14.674347 17.671227 13.428307 18 12 18 C 6.604 18 3.832375 13.411906 3.109375 12.003906 C 3.5249986 11.207948 4.6402378 9.3628241 6.5117188 7.9257812 z M 12.212891 8.0214844 L 15.978516 11.787109 C 15.869516 9.7541094 14.245891 8.1304844 12.212891 8.0214844 z M 10.074219 11.488281 L 12.511719 13.925781 C 12.347951 13.969804 12.177911 14 12 14 C 10.897 14 10 13.103 10 12 C 10 11.822089 10.030196 11.652049 10.074219 11.488281 z" />
    </SvgIcon>
  );
}

export function Divider(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 9 3 L 9 11 L 6 11 L 6 8 L 2 12 L 6 16 L 6 13 L 9 13 L 9 21 L 11 21 L 11 3 L 9 3 z M 13 3 L 13 21 L 15 21 L 15 13 L 18 13 L 18 16 L 22 12 L 18 8 L 18 11 L 15 11 L 15 3 L 13 3 z" />
    </SvgIcon>
  );
}

export function Paper(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 6 2 C 4.9057453 2 4 2.9057453 4 4 L 4 20 C 4 21.094255 4.9057453 22 6 22 L 14 22 L 20 16 L 20 15.585938 L 20 4 C 20 2.9057453 19.094255 2 18 2 L 6 2 z M 6 4 L 18 4 L 18 15 L 13 15 L 13 20 L 6 20 L 6 4 z" />
    </SvgIcon>
  );
}

export function Card(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4 4 C 2.9069372 4 2 4.9069372 2 6 L 2 18 C 2 19.093063 2.9069372 20 4 20 L 20 20 C 21.093063 20 22 19.093063 22 18 L 22 6 C 22 4.9069372 21.093063 4 20 4 L 4 4 z M 4 6 L 20 6 L 20 18 L 4 18 L 4 6 z" />
    </SvgIcon>
  );
}

export function CardActions(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 3 3 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 3 L 19 3 L 19 19 L 5 19 L 5 3 L 3 3 z M 7 3 L 7 5 L 17 5 L 17 3 L 7 3 z M 7 7 L 7 9 L 14 9 L 14 7 L 7 7 z M 7 13 L 7 17 L 17 17 L 17 13 L 7 13 z" />
    </SvgIcon>
  );
}
export function CardContent(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 5 C 21 3.9069372 20.093063 3 19 3 L 5 3 z M 5 5 L 19 5 L 19 19 L 5 19 L 5 5 z M 7 7 L 7 9 L 17 9 L 17 7 L 7 7 z M 7 11 L 7 13 L 13 13 L 13 11 L 7 11 z M 7 15 L 7 17 L 17 17 L 17 15 L 7 15 z" />
    </SvgIcon>
  );
}
export function CardHeader(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 21 L 5 21 L 5 5 L 19 5 L 19 21 L 21 21 L 21 5 C 21 3.9069372 20.093063 3 19 3 L 5 3 z M 7 7 L 7 11 L 17 11 L 17 7 L 7 7 z M 7 15 L 7 17 L 17 17 L 17 15 L 7 15 z M 7 19 L 7 21 L 14 21 L 14 19 L 7 19 z" />
    </SvgIcon>
  );
}
export function CardMedia(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 20 C 3 21.093063 3.9069372 22 5 22 L 19 22 C 20.093063 22 21 21.093063 21 20 L 21 5 C 21 3.9069372 20.093063 3 19 3 L 5 3 z M 5 5 L 19 5 L 19 20 L 5 20 L 5 5 z M 7 6 L 7 8 L 17 8 L 17 6 L 7 6 z M 7 10 L 7 15 L 17 15 L 17 10 L 7 10 z M 7 17 L 7 19 L 17 19 L 17 17 L 7 17 z" />
    </SvgIcon>
  );
}
export function ButtonGroup(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 2 7 C 0.9069372 7 0 7.9069372 0 9 L 0 15 C 0 16.093063 0.9069372 17 2 17 L 22 17 C 23.093063 17 24 16.093063 24 15 L 24 9 C 24 7.9069372 23.093063 7 22 7 L 2 7 z M 2 9 L 22 9 L 22 15 L 2 15 L 2 9 z M 7 11 L 7 13 L 9 13 L 9 11 L 7 11 z M 11 11 L 11 13 L 13 13 L 13 11 L 11 11 z M 15 11 L 15 13 L 17 13 L 17 11 L 15 11 z" />
    </SvgIcon>
  );
}

export function List(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 3 4.5 A 1.5 1.5 0 0 0 1.5 6 A 1.5 1.5 0 0 0 3 7.5 A 1.5 1.5 0 0 0 4.5 6 A 1.5 1.5 0 0 0 3 4.5 z M 7 5 L 7 7 L 22 7 L 22 5 L 7 5 z M 3 10.5 A 1.5 1.5 0 0 0 1.5 12 A 1.5 1.5 0 0 0 3 13.5 A 1.5 1.5 0 0 0 4.5 12 A 1.5 1.5 0 0 0 3 10.5 z M 7 11 L 7 13 L 22 13 L 22 11 L 7 11 z M 3 16.5 A 1.5 1.5 0 0 0 1.5 18 A 1.5 1.5 0 0 0 3 19.5 A 1.5 1.5 0 0 0 4.5 18 A 1.5 1.5 0 0 0 3 16.5 z M 7 17 L 7 19 L 22 19 L 22 17 L 7 17 z" />
    </SvgIcon>
  );
}

export function ListItem(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4 3 C 2.897 3 2 3.897 2 5 L 2 9 C 2 10.103 2.897 11 4 11 L 8 11 C 9.103 11 10 10.103 10 9 L 10 5 C 10 3.897 9.103 3 8 3 L 4 3 z M 12 4 L 12 6 L 13 6 L 21 6 L 22 6 L 22 4 L 21 4 L 13 4 L 12 4 z M 5 6 L 7 6 L 7 8 L 5 8 L 5 6 z M 12 8 L 12 10 L 13 10 L 18 10 L 19 10 L 19 8 L 18 8 L 13 8 L 12 8 z M 4 13 C 2.897 13 2 13.897 2 15 L 2 19 C 2 20.103 2.897 21 4 21 L 8 21 C 9.103 21 10 20.103 10 19 L 10 15 C 10 13.897 9.103 13 8 13 L 4 13 z M 12 14 L 12 16 L 13 16 L 21 16 L 22 16 L 22 14 L 21 14 L 13 14 L 12 14 z M 6 16 C 6.552 16 7 16.448 7 17 C 7 17.552 6.552 18 6 18 C 5.448 18 5 17.552 5 17 C 5 16.448 5.448 16 6 16 z M 12 18 L 12 20 L 13 20 L 18 20 L 19 20 L 19 18 L 18 18 L 13 18 L 12 18 z" />
    </SvgIcon>
  );
}
export function Image(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4 4 C 2.9069372 4 2 4.9069372 2 6 L 2 18 C 2 19.093063 2.9069372 20 4 20 L 20 20 C 21.093063 20 22 19.093063 22 18 L 22 6 C 22 4.9069372 21.093063 4 20 4 L 4 4 z M 4 6 L 20 6 L 20 18 L 4 18 L 4 6 z M 10 8 A 1 1 0 0 0 9 9 A 1 1 0 0 0 10 10 A 1 1 0 0 0 11 9 A 1 1 0 0 0 10 8 z M 14.5 11 L 11 15 L 8.5 12.5 L 5.7773438 16 L 18.25 16 L 14.5 11 z" />
    </SvgIcon>
  );
}
export function Dropdown(props) {
  return (
    <svg
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 2 6 C 0.9069372 6 0 6.9069372 0 8 L 0 16 C 0 17.093063 0.9069372 18 2 18 L 22 18 C 23.093063 18 24 17.093063 24 16 L 24 8 C 24 6.9069372 23.093063 6 22 6 L 2 6 z M 2 8 L 14 8 L 14 16 L 2 16 L 2 8 z M 16 8 L 22 8 L 22 16 L 16 16 L 16 8 z M 17 11 L 19 13 L 21 11 L 17 11 z" />
    </svg>
  );
}

export function Tab(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 5 3 C 3.895 3 3 3.895 3 5 L 3 19 C 3 20.105 3.895 21 5 21 L 19 21 C 20.105 21 21 20.105 21 19 L 21 9 L 21 8.5 L 21 5 C 21 3.897 20.103 3 19 3 L 11.443359 3 C 11.787359 3.591 12 4.268 12 5 L 19 5 L 19 7 L 10 7 L 10 5 C 10 3.895 9.105 3 8 3 L 5 3 z M 5 5 L 8 5 L 8 9 L 19 9 L 19 19 L 5 19 L 5 5 z" />
    </SvgIcon>
  );
}

export function Collapse(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path fill="none" d="M0 0H24V24H0z" />
      <path d="M10 2c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1H8v2h5V9c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1h-6c-.552 0-1-.448-1-1v-1H8v6h5v-1c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1h-6c-.552 0-1-.448-1-1v-1H7c-.552 0-1-.448-1-1V8H4c-.552 0-1-.448-1-1V3c0-.552.448-1 1-1h6zm9 16h-4v2h4v-2zm0-8h-4v2h4v-2zM9 4H5v2h4V4z" />
    </SvgIcon>
  );
}

export function Tabpanel(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4 4 C 2.9069372 4 2 4.9069372 2 6 L 2 18 C 2 19.093063 2.9069372 20 4 20 L 20 20 C 21.093063 20 22 19.093063 22 18 L 22 6 C 22 4.9069372 21.093063 4 20 4 L 4 4 z M 4 6 L 20 6 L 20 18 L 4 18 L 4 6 z" />
    </SvgIcon>
  );
}

export function Button(props) {
  return (
    <svg
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4 12 C 1.800781 12 0 13.800781 0 16 L 0 34 C 0 36.199219 1.800781 38 4 38 L 46 38 C 48.199219 38 50 36.199219 50 34 L 50 16 C 50 13.800781 48.199219 12 46 12 Z M 4 14 L 46 14 C 47.117188 14 48 14.882813 48 16 L 48 34 C 48 35.117188 47.117188 36 46 36 L 4 36 C 2.882813 36 2 35.117188 2 34 L 2 16 C 2 14.882813 2.882813 14 4 14 Z M 33.527344 22.308594 C 31.835938 22.308594 30.746094 23.445313 30.746094 25.277344 C 30.746094 27.113281 31.824219 28.25 33.527344 28.25 C 35.21875 28.25 36.296875 27.113281 36.296875 25.277344 C 36.296875 23.445313 35.21875 22.308594 33.527344 22.308594 Z M 6.914063 22.464844 L 6.914063 28.097656 L 9.617188 28.097656 C 10.824219 28.097656 11.589844 27.460938 11.589844 26.472656 C 11.589844 25.753906 11.015625 25.179688 10.28125 25.140625 L 10.28125 25.066406 C 10.878906 24.984375 11.328125 24.472656 11.328125 23.867188 C 11.328125 22.992188 10.667969 22.464844 9.542969 22.464844 Z M 13.015625 22.464844 L 13.015625 26.152344 C 13.015625 27.417969 13.980469 28.25 15.445313 28.25 C 16.910156 28.25 17.871094 27.417969 17.871094 26.152344 L 17.871094 22.464844 L 16.4375 22.464844 L 16.4375 26 C 16.4375 26.65625 16.082031 27.046875 15.445313 27.046875 C 14.808594 27.046875 14.449219 26.65625 14.449219 26 L 14.449219 22.464844 Z M 19.296875 22.464844 L 19.296875 23.613281 L 20.921875 23.613281 L 20.921875 28.097656 L 22.347656 28.097656 L 22.347656 23.613281 L 23.980469 23.613281 L 23.980469 22.464844 Z M 25.089844 22.464844 L 25.089844 23.613281 L 26.714844 23.613281 L 26.714844 28.097656 L 28.144531 28.097656 L 28.144531 23.613281 L 29.773438 23.613281 L 29.773438 22.464844 Z M 37.761719 22.464844 L 37.761719 28.097656 L 39.121094 28.097656 L 39.121094 24.894531 L 39.195313 24.894531 L 41.550781 28.097656 L 42.6875 28.097656 L 42.6875 22.464844 L 41.328125 22.464844 L 41.328125 25.636719 L 41.253906 25.636719 L 38.90625 22.464844 Z M 8.347656 23.472656 L 9.160156 23.472656 C 9.648438 23.472656 9.933594 23.714844 9.933594 24.117188 C 9.933594 24.515625 9.628906 24.761719 9.105469 24.761719 L 8.347656 24.761719 Z M 33.523438 23.496094 C 34.3125 23.496094 34.839844 24.191406 34.839844 25.277344 C 34.839844 26.367188 34.316406 27.0625 33.523438 27.0625 C 32.722656 27.0625 32.203125 26.367188 32.203125 25.277344 C 32.203125 24.191406 32.730469 23.496094 33.523438 23.496094 Z M 8.347656 25.628906 L 9.203125 25.628906 C 9.800781 25.628906 10.132813 25.886719 10.132813 26.347656 C 10.132813 26.824219 9.808594 27.089844 9.214844 27.089844 L 8.347656 27.089844 Z" />
    </svg>
  );
}

export function Select(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 2 6 C 0.9069372 6 0 6.9069372 0 8 L 0 16 C 0 17.093063 0.9069372 18 2 18 L 22 18 C 23.093063 18 24 17.093063 24 16 L 24 8 C 24 6.9069372 23.093063 6 22 6 L 2 6 z M 2 8 L 14 8 L 14 16 L 2 16 L 2 8 z M 16 8 L 22 8 L 22 16 L 16 16 L 16 8 z M 17 11 L 19 13 L 21 11 L 17 11 z" />
    </SvgIcon>
  );
}
export function Link(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 6 7 C 3.239 7 1 9.239 1 12 C 1 14.761 3.239 17 6 17 L 10 17 L 10 15 L 6 15 C 4.343 15 3 13.657 3 12 C 3 10.343 4.343 9 6 9 L 10 9 L 10 7 L 6 7 z M 14 7 L 14 9 L 18 9 C 19.657 9 21 10.343 21 12 C 21 13.657 19.657 15 18 15 L 14 15 L 14 17 L 18 17 C 20.761 17 23 14.761 23 12 C 23 9.239 20.761 7 18 7 L 14 7 z M 7 11 L 7 13 L 17 13 L 17 11 L 7 11 z" />
    </SvgIcon>
  );
}
export function TextInput(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 2 6 C 0.9069372 6 0 6.9069372 0 8 L 0 16 C 0 17.093063 0.9069372 18 2 18 L 22 18 C 23.093063 18 24 17.093063 24 16 L 24 8 C 24 6.9069372 23.093063 6 22 6 L 2 6 z M 2 8 L 22 8 L 22 16 L 2 16 L 2 8 z M 4 12 L 4 14 L 6 14 L 6 12 L 4 12 z M 8 12 L 8 14 L 10 14 L 10 12 L 8 12 z M 12 12 L 12 14 L 14 14 L 14 12 L 12 12 z" />
    </SvgIcon>
  );
}

export function TextArea(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 5 2 L 5 4 L 11 4 L 11 16 L 13 16 L 13 4 L 19 4 L 19 2 L 5 2 z M 7 16 L 4 19 L 7 22 L 7 20 L 17 20 L 17 22 L 20 19 L 17 16 L 17 18 L 7 18 L 7 16 z" />
    </SvgIcon>
  );
}

export function Switch(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 7 6 C 3.691 6 1 8.691 1 12 C 1 15.309 3.691 18 7 18 L 17 18 C 20.309 18 23 15.309 23 12 C 23 8.691 20.309 6 17 6 L 7 6 z M 7 8 L 17 8 C 19.206 8 21 9.794 21 12 C 21 14.206 19.206 16 17 16 L 7 16 C 4.794 16 3 14.206 3 12 C 3 9.794 4.794 8 7 8 z M 17 9 A 3 3 0 0 0 14 12 A 3 3 0 0 0 17 15 A 3 3 0 0 0 20 12 A 3 3 0 0 0 17 9 z" />
    </SvgIcon>
  );
}

export function Radio(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 7 5 C 3.1458514 5 0 8.1458514 0 12 C 0 15.854149 3.1458514 19 7 19 C 10.854149 19 14 15.854149 14 12 C 14 8.1458514 10.854149 5 7 5 z M 7 7 C 9.7732684 7 12 9.2267316 12 12 C 12 14.773268 9.7732684 17 7 17 C 4.2267316 17 2 14.773268 2 12 C 2 9.2267316 4.2267316 7 7 7 z M 7 10 C 5.895 10 5 10.895 5 12 C 5 13.105 5.895 14 7 14 C 8.105 14 9 13.105 9 12 C 9 10.895 8.105 10 7 10 z M 16 11 L 16 13 L 24 13 L 24 11 L 16 11 z" />
    </SvgIcon>
  );
}

export function Checkbox(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 2 5 C 0.9069372 5 0 5.9069372 0 7 L 0 17 C 0 18.093063 0.9069372 19 2 19 L 12 19 C 13.093063 19 14 18.093063 14 17 L 14 7 C 14 5.9069372 13.093063 5 12 5 L 2 5 z M 2 7 L 12 7 L 12 7.5859375 L 7 12.585938 L 4.2050781 9.7890625 L 2.7890625 11.205078 L 7 15.414062 L 12 10.414062 L 12 17 L 2 17 L 2 7 z M 16 11 L 16 13 L 24 13 L 24 11 L 16 11 z" />
    </SvgIcon>
  );
}

export function MultiSelect(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 2 6 C 0.9069372 6 0 6.9069372 0 8 L 0 16 C 0 17.093063 0.9069372 18 2 18 L 22 18 C 23.093063 18 24 17.093063 24 16 L 24 8 C 24 6.9069372 23.093063 6 22 6 L 2 6 z M 2 8 L 14 8 L 14 16 L 2 16 L 2 8 z M 16 8 L 22 8 L 22 16 L 16 16 L 16 8 z M 17 11 L 19 13 L 21 11 L 17 11 z" />
    </SvgIcon>
  );
}

export function RangePicker(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 7 3 C 5.9069372 3 5 3.9069372 5 5 L 5 10 L 1 10 L 1 12 L 5 12 L 5 17.539062 C 5 18.1233 5.2566739 18.677851 5.6972656 19.056641 L 5.6972656 19.058594 L 9.5 22.316406 L 13.302734 19.058594 L 13.302734 19.056641 C 13.743326 18.677898 14 18.1233 14 17.539062 L 14 5 C 14 3.9069372 13.093063 3 12 3 L 7 3 z M 7 5 L 12 5 L 12 17.539062 L 9.5 19.683594 L 7 17.539062 L 7 5 z M 16 10 L 16 12 L 23 12 L 23 10 L 16 10 z" />
    </SvgIcon>
  );
}
export function Upload(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      {" "}
      <path d="M 12 3 C 9.6655084 3 7.7006133 4.2494956 6.4296875 6.0136719 C 2.8854572 6.05389 0 8.9465993 0 12.5 C 0 16.078268 2.9217323 19 6.5 19 L 9 19 L 9 17 L 6.5 17 C 4.0022677 17 2 14.997732 2 12.5 C 2 10.002268 4.0022677 8 6.5 8 C 6.534993 8 6.6164592 8.0069899 6.75 8.0136719 L 7.3613281 8.0449219 L 7.6660156 7.5136719 C 8.5301088 6.0123517 10.137881 5 12 5 C 14.504527 5 16.55398 6.8254912 16.931641 9.2148438 L 17.083984 10.175781 L 18.048828 10.050781 C 18.272182 10.021699 18.414903 10 18.5 10 C 20.444423 10 22 11.555577 22 13.5 C 22 15.444423 20.444423 17 18.5 17 L 15 17 L 15 19 L 18.5 19 C 21.525577 19 24 16.525577 24 13.5 C 24 10.509638 21.577034 8.0762027 18.599609 8.0195312 C 17.729938 5.1415745 15.152096 3 12 3 z M 12 9 L 8 13 L 11 13 L 11 21 L 13 21 L 13 13 L 16 13 L 12 9 z" />
    </SvgIcon>
  );
}
export function DateTimepicker(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 6 1 L 6 3 L 5 3 C 3.9 3 3 3.9 3 5 L 3 19 C 3 20.1 3.9 21 5 21 L 19 21 C 20.1 21 21 20.1 21 19 L 21 5 C 21 3.9 20.1 3 19 3 L 18 3 L 18 1 L 16 1 L 16 3 L 8 3 L 8 1 L 6 1 z M 5 5 L 19 5 L 19 7 L 5 7 L 5 5 z M 5 9 L 19 9 L 19 19 L 5 19 L 5 9 z M 12 10 L 9 13 L 15 13 L 12 10 z M 9 15 L 12 18 L 15 15 L 9 15 z" />
    </SvgIcon>
  );
}

export function Text(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 5 2 L 5 4 L 11 4 L 11 16 L 13 16 L 13 4 L 19 4 L 19 2 L 5 2 z M 7 16 L 4 19 L 7 22 L 7 20 L 17 20 L 17 22 L 20 19 L 17 16 L 17 18 L 7 18 L 7 16 z" />
    </SvgIcon>
  );
}
export function H1(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path fill="none" d="M0 0H24V24H0z" />
      <path
        d="M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16zm8-12v12h-2v-9.796l-2 .536V8.67L19.5 8H21z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function H2(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path fill="none" d="M0 0H24V24H0z" />
      <path
        d="M4 4v7h7V4h2v16h-2v-7H4v7H2V4h2zm14.5 4c2.071 0 3.75 1.679 3.75 3.75 0 .857-.288 1.648-.772 2.28l-.148.18L18.034 18H22v2h-7v-1.556l4.82-5.546c.268-.307.43-.709.43-1.148 0-.966-.784-1.75-1.75-1.75-.918 0-1.671.707-1.744 1.606l-.006.144h-2C14.75 9.679 16.429 8 18.5 8z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function H6(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="currentColor"
      {...props}
    >
      <path fill="none" d="M0 0H24V24H0z" />
      <path
        d="M21.097 8l-2.598 4.5c2.21 0 4.001 1.79 4.001 4s-1.79 4-4 4-4-1.79-4-4c0-.736.199-1.426.546-2.019L18.788 8h2.309zM4 4v7h7V4h2v16h-2v-7H4v7H2V4h2zm14.5 10.5c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function Badge(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="currentColor"
      {...props}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M13.341 4A5.99 5.99 0 0 0 13 6H5v14h14v-8a5.99 5.99 0 0 0 2-.341V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9.341zM19 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function Avatar(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 12 2 C 6.477 2 2 6.477 2 12 C 2 17.523 6.477 22 12 22 C 17.523 22 22 17.523 22 12 C 22 6.477 17.523 2 12 2 z M 12 4 C 16.418 4 20 7.582 20 12 C 20 13.597292 19.525404 15.081108 18.71875 16.330078 L 17.949219 15.734375 C 16.397219 14.537375 13.537 14 12 14 C 10.463 14 7.6017813 14.537375 6.0507812 15.734375 L 5.28125 16.332031 C 4.4740429 15.082774 4 13.597888 4 12 C 4 7.582 7.582 4 12 4 z M 12 5.75 C 10.208 5.75 8.75 7.208 8.75 9 C 8.75 10.792 10.208 12.25 12 12.25 C 13.792 12.25 15.25 10.792 15.25 9 C 15.25 7.208 13.792 5.75 12 5.75 z M 12 7.75 C 12.689 7.75 13.25 8.311 13.25 9 C 13.25 9.689 12.689 10.25 12 10.25 C 11.311 10.25 10.75 9.689 10.75 9 C 10.75 8.311 11.311 7.75 12 7.75 z M 12 16 C 15.100714 16 16.768095 17.168477 17.548828 17.753906 C 16.109984 19.141834 14.156852 20 12 20 C 9.843148 20 7.8900164 19.141834 6.4511719 17.753906 C 7.231905 17.168477 8.899286 16 12 16 z M 6.0546875 17.339844 C 6.1756559 17.473131 6.297271 17.605851 6.4257812 17.730469 C 6.2971141 17.605286 6.1747276 17.473381 6.0546875 17.339844 z M 17.912109 17.375 C 17.802435 17.495543 17.692936 17.616825 17.576172 17.730469 C 17.692621 17.617521 17.801457 17.494978 17.912109 17.375 z" />
    </SvgIcon>
  );
}
export function Chip(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 2 6 C 0.9069372 6 0 6.9069372 0 8 L 0 16 C 0 17.093063 0.9069372 18 2 18 L 22 18 C 23.093063 18 24 17.093063 24 16 L 24 8 C 24 6.9069372 23.093063 6 22 6 L 2 6 z M 2 8 L 14 8 L 14 16 L 2 16 L 2 8 z M 16 8 L 22 8 L 22 16 L 16 16 L 16 8 z M 17 11 L 19 13 L 21 11 L 17 11 z" />
    </SvgIcon>
  );
}

export function Carousel(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 7 3 A 1.0001 1.0001 0 0 0 6 4 L 6 5 L 3 5 A 1.0001 1.0001 0 0 0 2 6 L 2 18 A 1.0001 1.0001 0 0 0 3 19 L 6 19 L 6 20 A 1.0001 1.0001 0 0 0 7 21 L 17 21 A 1.0001 1.0001 0 0 0 18 20 L 18 19 L 21 19 A 1.0001 1.0001 0 0 0 22 18 L 22 6 A 1.0001 1.0001 0 0 0 21 5 L 18 5 L 18 4 A 1.0001 1.0001 0 0 0 17 3 L 7 3 z M 8 5 L 16 5 L 16 5.8320312 A 1.0001 1.0001 0 0 0 16 6.1582031 L 16 17.832031 A 1.0001 1.0001 0 0 0 16 18.158203 L 16 19 L 8 19 L 8 18.167969 A 1.0001 1.0001 0 0 0 8 17.841797 L 8 6.1679688 A 1.0001 1.0001 0 0 0 8 5.8417969 L 8 5 z M 4 7 L 6 7 L 6 17 L 4 17 L 4 7 z M 18 7 L 20 7 L 20 17 L 18 17 L 18 7 z" />
    </SvgIcon>
  );
}

export function Alert(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 12 2 C 6.4889941 2 2 6.4889982 2 12 C 2 17.511002 6.4889941 22 12 22 C 17.511006 22 22 17.511002 22 12 C 22 6.4889982 17.511006 2 12 2 z M 12 4 C 16.430126 4 20 7.5698765 20 12 C 20 16.430123 16.430126 20 12 20 C 7.5698737 20 4 16.430123 4 12 C 4 7.5698765 7.5698737 4 12 4 z M 11 7 L 11 13 L 13 13 L 13 7 L 11 7 z M 11 15 L 11 17 L 13 17 L 13 15 L 11 15 z" />
    </SvgIcon>
  );
}
export function CircularProgress(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 12 2 C 6.824 2 2.5537813 5.954 2.0507812 11 L 4.0683594 11 C 4.5633594 7.06 7.928 4 12 4 C 16.072 4 19.436641 7.06 19.931641 11 L 21.949219 11 C 21.445219 5.954 17.176 2 12 2 z M 2.0507812 13 C 2.2507813 15.008 3.0545781 16.837359 4.2675781 18.318359 L 5.6875 16.898438 C 4.8295 15.792438 4.2513594 14.457 4.0683594 13 L 2.0507812 13 z M 18.271484 16.929688 C 17.857484 17.454687 17.385469 17.932844 16.855469 18.339844 L 17.867188 20.074219 C 18.680187 19.483219 19.398953 18.769797 20.001953 17.966797 L 18.271484 16.929688 z M 7.1035156 18.310547 L 5.6816406 19.732422 C 6.9876406 20.801422 8.5659219 21.549563 10.294922 21.851562 L 10.4375 19.839844 C 9.2005 19.591844 8.0645156 19.059547 7.1035156 18.310547 z M 15.130859 19.351562 C 14.294859 19.708562 13.384641 19.928469 12.431641 19.980469 L 12.289062 21.986328 C 13.661062 21.947328 14.960625 21.621031 16.140625 21.082031 L 15.130859 19.351562 z" />
    </SvgIcon>
  );
}
export function Drawer(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
      fill="currentColor"
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm5 2H4v14h4V5zm2 0v14h10V5H10z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function Modal(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 3.9980469 3 C 2.8980469 3 2.0097656 3.9 2.0097656 5 L 2 16.998047 C 2 18.103047 2.895 19 4 19 L 5.9980469 19 L 5.9980469 23 L 9.9980469 19 L 10.068359 19 C 10.027359 18.672 10 18.339 10 18 C 10 17.661 10.027359 17.328 10.068359 17 L 5.9980469 17 L 4 17 L 3.9980469 5 L 19.998047 5 L 19.998047 10.261719 C 20.708047 10.444719 21.379047 10.720125 21.998047 11.078125 L 21.998047 5 C 21.998047 3.9 21.098047 3 19.998047 3 L 3.9980469 3 z M 18 12 C 14.698136 12 12 14.698136 12 18 C 12 21.301864 14.698136 24 18 24 C 21.301864 24 24 21.301864 24 18 C 24 14.698136 21.301864 12 18 12 z M 18 14 C 20.220984 14 22 15.779016 22 18 C 22 20.220984 20.220984 22 18 22 C 15.779016 22 14 20.220984 14 18 C 14 15.779016 15.779016 14 18 14 z M 17 16 L 17 20 L 19 20 L 19 16 L 17 16 z" />
    </SvgIcon>
  );
}

export function DialogActions(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 3 3 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 3 L 19 3 L 19 19 L 5 19 L 5 3 L 3 3 z M 7 3 L 7 5 L 17 5 L 17 3 L 7 3 z M 7 7 L 7 9 L 14 9 L 14 7 L 7 7 z M 7 13 L 7 17 L 17 17 L 17 13 L 7 13 z" />
    </SvgIcon>
  );
}
export function DialogContent(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 5 C 21 3.9069372 20.093063 3 19 3 L 5 3 z M 5 5 L 19 5 L 19 19 L 5 19 L 5 5 z M 7 7 L 7 9 L 17 9 L 17 7 L 7 7 z M 7 11 L 7 13 L 13 13 L 13 11 L 7 11 z M 7 15 L 7 17 L 17 17 L 17 15 L 7 15 z" />
    </SvgIcon>
  );
}
export function DialogTitle(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 21 L 5 21 L 5 5 L 19 5 L 19 21 L 21 21 L 21 5 C 21 3.9069372 20.093063 3 19 3 L 5 3 z M 7 7 L 7 11 L 17 11 L 17 7 L 7 7 z M 7 15 L 7 17 L 17 17 L 17 15 L 7 15 z M 7 19 L 7 21 L 14 21 L 14 19 L 7 19 z" />
    </SvgIcon>
  );
}
export function TopHeader(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18zM4 10v9h16v-9H4zm0-2h16V5H4v3z" />
    </SvgIcon>
  );
}
export function Snackbar(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 2 6 C 0.9069372 6 0 6.9069372 0 8 L 0 16 C 0 17.093063 0.9069372 18 2 18 L 22 18 C 23.093063 18 24 17.093063 24 16 L 24 8 C 24 6.9069372 23.093063 6 22 6 L 2 6 z M 2 8 L 22 8 L 22 16 L 2 16 L 2 8 z M 4 12 L 4 14 L 6 14 L 6 12 L 4 12 z M 8 12 L 8 14 L 10 14 L 10 12 L 8 12 z M 12 12 L 12 14 L 14 14 L 14 12 L 12 12 z" />
    </SvgIcon>
  );
}
export function SideMenu(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M4 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4zm4-11H5v9h3v-9zm11 0h-9v9h9v-9zm0-5H5v3h14V5z" />
    </SvgIcon>
  );
}
export function BorderLinearProgress(props) {
  return (
    <SvgIcon
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z" />
    </SvgIcon>
  );
}
export function Table(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 11.984375 1.9863281 A 1.0001 1.0001 0 0 0 11.839844 2 L 4 2 A 1.0001 1.0001 0 0 0 3 3 L 3 8.8320312 A 1.0001 1.0001 0 0 0 3 9.1582031 L 3 14.832031 A 1.0001 1.0001 0 0 0 3 15.158203 L 3 21 A 1.0001 1.0001 0 0 0 4 22 L 11.832031 22 A 1.0001 1.0001 0 0 0 12.158203 22 L 20 22 A 1.0001 1.0001 0 0 0 21 21 L 21 15.167969 A 1.0001 1.0001 0 0 0 21 14.841797 L 21 9.1679688 A 1.0001 1.0001 0 0 0 21 8.8417969 L 21 3 A 1.0001 1.0001 0 0 0 20 2 L 12.154297 2 A 1.0001 1.0001 0 0 0 11.984375 1.9863281 z M 5 4 L 11 4 L 11 8 L 5 8 L 5 4 z M 13 4 L 19 4 L 19 8 L 13 8 L 13 4 z M 5 10 L 11 10 L 11 14 L 5 14 L 5 10 z M 13 10 L 19 10 L 19 14 L 13 14 L 13 10 z M 5 16 L 11 16 L 11 20 L 5 20 L 5 16 z M 13 16 L 19 16 L 19 20 L 13 20 L 13 16 z" />
    </SvgIcon>
  );
}
export function TapSelect(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 7 2 L 7 18.5 L 11.09375 14.605469 L 14.300781 22 L 16.5 21 L 13.195312 13.701172 L 13.199219 13.699219 L 19 13.199219 L 7 2 z M 9 6.6015625 L 14.347656 11.59375 L 13.029297 11.707031 L 12.708984 11.734375 L 12.412109 11.861328 L 10.3125 12.761719 L 9.9824219 12.904297 L 9.7226562 13.152344 L 9 13.837891 L 9 6.6015625 z" />
    </SvgIcon>
  );
}
export function LocationSearch(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 12 2.0097656 C 8.144 2.0097656 5.0078125 5.1479063 5.0078125 9.0039062 C 5.0078125 13.486906 10.974516 20.769172 11.228516 21.076172 L 12 22.011719 L 12.771484 21.076172 C 13.025484 20.768172 18.992188 13.486906 18.992188 9.0039062 C 18.992187 5.1469062 15.856 2.0097656 12 2.0097656 z M 12 4.0097656 C 14.753 4.0097656 16.992188 6.2509062 16.992188 9.0039062 C 16.992187 11.708906 13.878 16.361172 12 18.826172 C 10.122 16.363172 7.0078125 11.712906 7.0078125 9.0039062 C 7.0078125 6.2509062 9.247 4.0097656 12 4.0097656 z M 12 6.5 C 10.619 6.5 9.5 7.619 9.5 9 C 9.5 10.381 10.619 11.5 12 11.5 C 13.381 11.5 14.5 10.381 14.5 9 C 14.5 7.619 13.381 6.5 12 6.5 z" />
    </SvgIcon>
  );
}
export function AutoSuggestion(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M5 5v14h14V5H5zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm5.869 12l-.82 2H6.833L11 7h2l4.167 10H14.95l-.82-2H9.87zm.82-2h2.622L12 9.8 10.689 13z" />
    </SvgIcon>
  );
}
export function BackgroundImage(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 3 3 C 1.9069372 3 1 3.9069372 1 5 L 1 15 C 1 16.093063 1.9069372 17 3 17 L 16 17 C 17.093063 17 18 16.093063 18 15 L 18 5 C 18 3.9069372 17.093063 3 16 3 L 3 3 z M 3 5 L 16 5 L 16 10.585938 L 13.498047 8.0820312 L 10.855469 10.746094 L 7.4570312 7.0761719 L 3 11.570312 L 3 5 z M 11 6 A 1 1 0 0 0 10 7 A 1 1 0 0 0 11 8 A 1 1 0 0 0 12 7 A 1 1 0 0 0 11 6 z M 20 7 L 20 19 L 5 19 L 5 21 L 20 21 C 21.093063 21 22 20.093063 22 19 L 22 7 L 20 7 z M 7.4082031 9.9667969 L 9.4453125 12.167969 L 9.0117188 12.605469 L 10.431641 14.013672 L 13.501953 10.916016 L 16 13.414062 L 16 15 L 3 15 L 3 14.414062 L 7.4082031 9.9667969 z" />
    </SvgIcon>
  );
}

export function OtpInput(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 2 6 C 0.9069372 6 0 6.9069372 0 8 L 0 16 C 0 17.093063 0.9069372 18 2 18 L 22 18 C 23.093063 18 24 17.093063 24 16 L 24 8 C 24 6.9069372 23.093063 6 22 6 L 2 6 z M 2 8 L 22 8 L 22 16 L 2 16 L 2 8 z M 3 9 L 3 11 L 4 11 L 4 15 L 6 15 L 6 9 L 3 9 z M 8 13 L 8 15 L 10 15 L 10 13 L 8 13 z M 12 13 L 12 15 L 14 15 L 14 13 L 12 13 z" />
    </SvgIcon>
  );
}
export function WeekCalendar(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 6 1 L 6 3 L 5 3 C 3.897 3 3 3.897 3 5 L 3 19 C 3 20.103 3.897 21 5 21 L 9 21 L 9 19 L 5 19 L 5 9 L 19 9 L 19 11 L 21 11 L 21 5 C 21 3.897 20.103 3 19 3 L 18 3 L 18 1 L 16 1 L 16 3 L 8 3 L 8 1 L 6 1 z M 5 5 L 19 5 L 19 7 L 5 7 L 5 5 z M 7 13 L 7 16 L 9 16 L 9 13 L 7 13 z M 13.5 13 C 12.130937 13 11 14.130937 11 15.5 L 11 18.5 C 11 19.869063 12.130937 21 13.5 21 C 14.869063 21 16 19.869063 16 18.5 L 16 15.5 C 16 14.130937 14.869063 13 13.5 13 z M 17 13 L 17 15 L 19.521484 15 L 17 21 L 19.128906 21 L 21.919922 14.478516 L 22 14.205078 L 22 13 L 17 13 z M 13.5 15 C 13.786937 15 14 15.213063 14 15.5 L 14 18.5 C 14 18.786937 13.786937 19 13.5 19 C 13.213063 19 13 18.786937 13 18.5 L 13 15.5 C 13 15.213063 13.213063 15 13.5 15 z" />
    </SvgIcon>
  );
}

export function Icons(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005V4.995zM5 5v14h14V5H5zm2.972 13.18a9.983 9.983 0 0 1-1.751-.978A6.994 6.994 0 0 1 12.102 14c2.4 0 4.517 1.207 5.778 3.047a9.995 9.995 0 0 1-1.724 1.025A4.993 4.993 0 0 0 12.102 16c-1.715 0-3.23.864-4.13 2.18zM12 13a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
    </SvgIcon>
  );
}
export function Div(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4 4 C 2.9069372 4 2 4.9069372 2 6 L 2 18 C 2 19.093063 2.9069372 20 4 20 L 20 20 C 21.093063 20 22 19.093063 22 18 L 22 6 C 22 4.9069372 21.093063 4 20 4 L 4 4 z M 4 6 L 20 6 L 20 18 L 4 18 L 4 6 z" />
    </SvgIcon>
  );
}

export function Translate(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M18.5 10l4.4 11h-2.155l-1.201-3h-4.09l-1.199 3h-2.154L16.5 10h2zM10 2v2h6v2h-1.968a18.222 18.222 0 0 1-3.62 6.301 14.864 14.864 0 0 0 2.336 1.707l-.751 1.878A17.015 17.015 0 0 1 9 13.725a16.676 16.676 0 0 1-6.201 3.548l-.536-1.929a14.7 14.7 0 0 0 5.327-3.042A18.078 18.078 0 0 1 4.767 8h2.24A16.032 16.032 0 0 0 9 10.877a16.165 16.165 0 0 0 2.91-4.876L2 6V4h6V2h2zm7.5 10.885L16.253 16h2.492L17.5 12.885z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function MobileNumberWithCode(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 7.5 1 C 6.12 1 5 2.12 5 3.5 L 5 20.5 C 5 21.88 6.12 23 7.5 23 L 16.5 23 C 17.88 23 19 21.88 19 20.5 L 19 16 L 17 16 L 17 18 L 7 18 L 7 4 L 19 4 L 19 3.5 C 19 2.12 17.88 1 16.5 1 L 7.5 1 z M 13 6 C 12.602 6 12.264516 6.2352656 12.103516 6.5722656 L 17 9.640625 L 21.90625 6.5878906 C 21.74825 6.2428906 21.404 6 21 6 L 13 6 z M 12 8.7578125 L 12 13 C 12 13.552 12.448 14 13 14 L 21 14 C 21.552 14 22 13.552 22 13 L 22 8.7792969 L 17 11.892578 L 12 8.7578125 z M 12 18.875 C 12.622 18.875 13.125 19.378 13.125 20 C 13.125 20.622 12.622 21.125 12 21.125 C 11.378 21.125 10.875 20.622 10.875 20 C 10.875 19.378 11.378 18.875 12 18.875 z" />
    </SvgIcon>
  );
}

export function Form(props) {
  return (
    <SvgIcon
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4 4 C 2.9069372 4 2 4.9069372 2 6 L 2 18 C 2 19.093063 2.9069372 20 4 20 L 20 20 C 21.093063 20 22 19.093063 22 18 L 22 6 C 22 4.9069372 21.093063 4 20 4 L 4 4 z M 4 6 L 20 6 L 20 18 L 4 18 L 4 6 z M 11 8 L 11 11 L 18 11 L 18 8 L 11 8 z M 6 9 L 6 11 L 9 11 L 9 9 L 6 9 z M 6 13 L 6 15 L 9 15 L 9 13 L 6 13 z M 11 13 L 11 16 L 18 16 L 18 13 L 11 13 z" />
    </SvgIcon>
  );
}
export function CustomForm(props) {
  return (
    <svg
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 5 3 C 3.895 3 3 3.895 3 5 L 3 19 C 3 20.105 3.895 21 5 21 L 19 21 C 20.105 21 21 20.105 21 19 L 21 5 C 21 3.895 20.105 3 19 3 L 5 3 z M 5 5 L 19 5 L 19 7 L 5 7 L 5 5 z M 5 9 L 19 9 L 19 19 L 5 19 L 5 9 z M 15.585938 10 L 14.585938 11 L 13 11 L 13 13 L 15.414062 13 L 17 11.414062 L 15.585938 10 z M 7 11 L 7 13 L 11 13 L 11 11 L 7 11 z M 15.585938 14 L 14.585938 15 L 13 15 L 13 17 L 15.414062 17 L 17 15.414062 L 15.585938 14 z M 7 15 L 7 17 L 11 17 L 11 15 L 7 15 z" />
    </svg>
  );
}
export function Chart(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4 3 L 4 18 C 4 19.093063 4.9069372 20 6 20 L 21 20 L 21 18 L 6 18 L 6 3 L 4 3 z M 20.292969 5.2929688 L 16 9.5859375 L 13 6.5859375 L 7.2929688 12.292969 L 8.7070312 13.707031 L 13 9.4140625 L 16 12.414062 L 21.707031 6.7070312 L 20.292969 5.2929688 z" />
    </SvgIcon>
  );
}

export function MockUI(props) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M5 8h14V5H5v3zm9 11v-9H5v9h9zm2 0h3v-9h-3v9zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function CustomCode(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 6 2 C 4.9057453 2 4 2.9057453 4 4 L 4 20 C 4 21.094255 4.9057453 22 6 22 L 18 22 C 19.094255 22 20 21.094255 20 20 L 20 8 L 14 2 L 6 2 z M 6 4 L 13 4 L 13 9 L 18 9 L 18 20 L 6 20 L 6 4 z M 11 11 C 10.03 11 9 11.701 9 13 L 9 14 L 8 15 L 9 16 L 9 17 C 9 18.299 10.03 19 11 19 L 11 16 C 11 15.633781 10.893178 15.29551 10.720703 15 C 10.893178 14.70449 11 14.366219 11 14 L 11 11 z M 13 11 L 13 14 C 13 14.366219 13.106822 14.70449 13.279297 15 C 13.106822 15.29551 13 15.633781 13 16 L 13 19 C 13.97 19 15 18.299 15 17 L 15 16 L 16 15 L 15 14 L 15 13 C 15 11.701 13.97 11 13 11 z" />
    </SvgIcon>
  );
}

export function Template(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 11 1 C 9.3550302 1 8 2.3550302 8 4 L 4 4 C 2.9069372 4 2 4.9069372 2 6 L 2 12 L 4 12 C 4.5650302 12 5 12.43497 5 13 C 5 13.56503 4.5650302 14 4 14 L 2 14 L 2 20 C 2 21.093063 2.9069372 22 4 22 L 10 22 L 10 20 C 10 19.43497 10.43497 19 11 19 C 11.56503 19 12 19.43497 12 20 L 12 22 L 18 22 C 19.093063 22 20 21.093063 20 20 L 20 16 C 21.64497 16 23 14.64497 23 13 C 23 11.35503 21.64497 10 20 10 L 20 6 C 20 4.9069372 19.093063 4 18 4 L 14 4 C 14 2.3550302 12.64497 1 11 1 z M 11 3 C 11.56503 3 12 3.4349698 12 4 L 12 6 L 18 6 L 18 12 L 20 12 C 20.56503 12 21 12.43497 21 13 C 21 13.56503 20.56503 14 20 14 L 18 14 L 18 20 L 14 20 C 14 18.35503 12.64497 17 11 17 C 9.3550302 17 8 18.35503 8 20 L 4 20 L 4 16 C 5.6449698 16 7 14.64497 7 13 C 7 11.35503 5.6449698 10 4 10 L 4 6 L 10 6 L 10 4 C 10 3.4349698 10.43497 3 11 3 z" />
    </SvgIcon>
  );
}

export function QRscan(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 480 480"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M0,62V32C0,14.355,14.355,0,32,0h30c4.418,0,8,3.582,8,8s-3.582,8-8,8H32c-8.822,0-16,7.178-16,16v30c0,4.418-3.582,8-8,8	S0,66.418,0,62z M448,0h-30c-4.418,0-8,3.582-8,8s3.582,8,8,8h30c8.822,0,16,7.178,16,16v30c0,4.418,3.582,8,8,8s8-3.582,8-8V32	C480,14.355,465.645,0,448,0z M62,464H32c-8.822,0-16-7.178-16-16v-30c0-4.418-3.582-8-8-8s-8,3.582-8,8v30	c0,17.645,14.355,32,32,32h30c4.418,0,8-3.582,8-8S66.418,464,62,464z M472,410c-4.418,0-8,3.582-8,8v30c0,8.822-7.178,16-16,16h-30	c-4.418,0-8,3.582-8,8s3.582,8,8,8h30c17.645,0,32-14.355,32-32v-30C480,413.582,476.418,410,472,410z M152,320H56	c-4.418,0-8,3.582-8,8s3.582,8,8,8h88v80H64v-48c0-4.418-3.582-8-8-8s-8,3.582-8,8v56c0,4.418,3.582,8,8,8h96c4.418,0,8-3.582,8-8	v-96C160,323.582,156.418,320,152,320z M48,56v96c0,4.418,3.582,8,8,8h96c4.418,0,8-3.582,8-8s-3.582-8-8-8H64V64h80v48	c0,4.418,3.582,8,8,8s8-3.582,8-8V56c0-4.418-3.582-8-8-8H56C51.582,48,48,51.582,48,56z M328,160c4.418,0,8-3.582,8-8V64h80v80h-48	c-4.418,0-8,3.582-8,8s3.582,8,8,8h56c4.418,0,8-3.582,8-8V56c0-4.418-3.582-8-8-8h-96c-4.418,0-8,3.582-8,8v96	C320,156.418,323.582,160,328,160z M432,424v-72c0-4.418-3.582-8-8-8s-8,3.582-8,8v64h-64c-4.418,0-8,3.582-8,8s3.582,8,8,8h72	C428.418,432,432,428.418,432,424z M96,88c-4.418,0-8,3.582-8,8v16c0,4.418,3.582,8,8,8h16c4.418,0,8-3.582,8-8V96	c0-4.418-3.582-8-8-8H96z M112,392c4.418,0,8-3.582,8-8v-16c0-4.418-3.582-8-8-8H96c-4.418,0-8,3.582-8,8v16c0,4.418,3.582,8,8,8	H112z M368,120h16c4.418,0,8-3.582,8-8V96c0-4.418-3.582-8-8-8h-16c-4.418,0-8,3.582-8,8v16C360,116.418,363.582,120,368,120z M392,376c0-4.418-3.582-8-8-8h-80c-4.418,0-8,3.582-8,8v40h-32c-4.418,0-8,3.582-8,8s3.582,8,8,8h40c4.418,0,8-3.582,8-8v-40h72	C388.418,384,392,380.418,392,376z M216,416h-24c-4.418,0-8,3.582-8,8s3.582,8,8,8h24c4.418,0,8-3.582,8-8S220.418,416,216,416z M56,270c-4.418,0-8,3.582-8,8s3.582,8,8,8h44c4.418,0,8-3.582,8-8s-3.582-8-8-8H56z M200,336c4.418,0,8-3.582,8-8v-50	c0-4.418-3.582-8-8-8h-50c-4.418,0-8,3.582-8,8s3.582,8,8,8h42v42C192,332.418,195.582,336,200,336z M256,336h56	c4.418,0,8-3.582,8-8s-3.582-8-8-8h-56v-50c0-4.418-3.582-8-8-8s-8,3.582-8,8v98h-48c-4.418,0-8,3.582-8,8s3.582,8,8,8h56	c4.418,0,8-3.582,8-8V336z M424,318c4.418,0,8-3.582,8-8v-48c0-4.418-3.582-8-8-8h-64c-4.418,0-8,3.582-8,8s3.582,8,8,8h56v40	C416,314.418,419.582,318,424,318z M360,320c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8s-3.582-8-8-8H360z M424,206	h-24c-4.418,0-8,3.582-8,8s3.582,8,8,8h24c4.418,0,8-3.582,8-8S428.418,206,424,206z M312,286c4.418,0,8-3.582,8-8v-56h31	c4.418,0,8-3.582,8-8s-3.582-8-8-8h-39c-4.418,0-8,3.582-8,8v64C304,282.418,307.582,286,312,286z M160,225v-27c0-4.418-3.582-8-8-8	s-8,3.582-8,8v19H56c-4.418,0-8,3.582-8,8s3.582,8,8,8h96C156.418,233,160,229.418,160,225z M200,190c4.418,0,8-3.582,8-8v-14h72	c4.418,0,8-3.582,8-8s-3.582-8-8-8h-72v-16c0-4.418-3.582-8-8-8s-8,3.582-8,8v46C192,186.418,195.582,190,200,190z M200,96h32	c4.418,0,8-3.582,8-8s-3.582-8-8-8h-24V56c0-4.418-3.582-8-8-8s-8,3.582-8,8v32C192,92.418,195.582,96,200,96z M200,235h72	c4.418,0,8-3.582,8-8s-3.582-8-8-8h-72c-4.418,0-8,3.582-8,8S195.582,235,200,235z M248,64h24v48c0,4.418,3.582,8,8,8s8-3.582,8-8	V56c0-4.418-3.582-8-8-8h-32c-4.418,0-8,3.582-8,8S243.582,64,248,64z" />
    </SvgIcon>
  );
}

export function IdmPanel(props) {
  return (
    <SvgIcon
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <path d="M 4 4 C 2.9069372 4 2 4.9069372 2 6 L 2 18 C 2 19.093063 2.9069372 20 4 20 L 20 20 C 21.093063 20 22 19.093063 22 18 L 22 6 C 22 4.9069372 21.093063 4 20 4 L 4 4 z M 4 6 L 20 6 L 20 18 L 4 18 L 4 6 z" />
    </SvgIcon>
  );
}
